// jpremiumタブリストとotherタブリストのタブ要素を取得
const tabMenusJpremium = document.querySelectorAll(
  ".p-roomlist-tabs__jpremium li"
);
const tabMenusOther = document.querySelectorAll(".p-roomlist-tabs__other li");

// タブのクリックイベントを設定
tabMenusJpremium.forEach((tabMenu) => {
  tabMenu.addEventListener("click", () => tabSwitch(tabMenu, "jpremium"));
});
tabMenusOther.forEach((tabMenu) => {
  tabMenu.addEventListener("click", () => tabSwitch(tabMenu, "other"));
});

// タブ切り替え処理
function tabSwitch(clickedTab, tabType) {
  // クリックされたタブがすでに選択中の場合は何もしない
  if (clickedTab.classList.contains("current")) {
    return;
  }

  // データ属性から対応するクラス名を取得
  const tabTargetClass = clickedTab.dataset.tab;

  // **すべてのタブグループをリセット**
  resetAllTabs();

  // 対応するタブメニューとタブパネルを取得
  const tabList = document.querySelector(`.p-roomlist-tabs__${tabType}`);
  const tabItems = tabList.querySelectorAll("li");
  const tabPanelItems = document.querySelectorAll(
    `.p-roomlist-contents__wrapper .p-roomlist-room`
  );

  // クリックされたタブにcurrentクラスを追加
  clickedTab.classList.add("current");

  // 最初に表示しているコンテンツのopacityを徐々に0にするアニメーション
  const currentTabPanelItem = document.querySelector(
    `.p-roomlist-contents__wrapper .p-roomlist-room.current`
  );
  if (currentTabPanelItem) {
    currentTabPanelItem.classList.add("fade-out");
  }

  // 対応するコンテンツにcurrentクラスを追加
  tabPanelItems.forEach((tabPanelItem) => {
    if (tabPanelItem.classList.contains(tabTargetClass)) {
      tabPanelItem.classList.add("current");
      tabPanelItem.classList.add("fade-in"); // 新しいコンテンツの表示アニメーション
    } else {
      tabPanelItem.classList.remove("current"); // 他の要素を非表示にする
    }
  });
  // スマホとPCで異なる位置にジャンプ
  const roomlistElement_sp = document.querySelector("#roomlist");
  const roomlistElement_pc = document.querySelector("#tabs");
  const header = document.querySelector("header"); // ヘッダー要素を取得

  if (window.innerWidth <= 768) {
    // スマホの場合
    if (roomlistElement_sp) {
      roomlistElement_sp.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  } else if (roomlistElement_pc) {
    // PCの場合
    const headerHeight = header ? header.offsetHeight : 0; // ヘッダーの高さを取得（存在しない場合は0）
    const targetPosition =
      roomlistElement_pc.getBoundingClientRect().top +
      window.scrollY -
      headerHeight;
    window.scrollTo({ top: targetPosition, behavior: "smooth" });
  }
}

// **すべてのタブグループをリセットする関数**
function resetAllTabs() {
  const allTabItems = document.querySelectorAll(
    ".p-roomlist-tabs__jpremium li, .p-roomlist-tabs__other li"
  );
  const allTabPanelItems = document.querySelectorAll(
    ".p-roomlist-contents__wrapper .p-roomlist-room"
  );

  // すべてのタブからcurrentクラスを削除
  allTabItems.forEach((tabItem) => {
    tabItem.classList.remove("current");
  });

  // すべてのタブパネルからcurrentクラスを削除
  allTabPanelItems.forEach((tabPanelItem) => {
    tabPanelItem.classList.remove("current");
    tabPanelItem.classList.remove("fade-in"); // アニメーションのリセット
  });
}

// すべてを再表示
const filterLink = document.getElementById("filterLink");
if (filterLink) {
  filterLink.addEventListener("click", (event) => {
    resetAllTabs_view();
  });
}

function resetAllTabs_view() {
  const allTabItems = document.querySelectorAll(
    ".p-roomlist-tabs__jpremium li, .p-roomlist-tabs__other li"
  );
  const allTabPanelItems = document.querySelectorAll(
    ".p-roomlist-contents__wrapper .p-roomlist-room"
  );
  const result = document.querySelector(".p-roomlist-result");

  // すべてのタブからcurrentクラスを削除
  allTabItems.forEach((tabItem) => {
    tabItem.classList.remove("current");
    tabItem.classList.remove("no_current");
  });
  // すべてのタブパネルにcurrentクラスを追加
  allTabPanelItems.forEach((tabPanelItem, index) => {
    tabPanelItem.classList.add("current");
    if (index === 0) {
      tabPanelItem.classList.add("fade-in");
    } else {
      tabPanelItem.classList.add("fade-out");
      tabPanelItem.classList.remove("fade-in");
    }
  });
  if (result) {
    result.style.visibility = "hidden";
  }
}
